const lang3 = (lang) => (lang.startsWith("ms") ? "ms" : lang.startsWith("en") ? "en" : "zh");
const ORDER = {
    new: { zh: "新订单", en: "New", ms: "Baru" },
    preparing: { zh: "备餐中", en: "Preparing", ms: "Sedang disediakan" },
    ready: { zh: "已备好", en: "Ready", ms: "Siap" },
    out_for_delivery: { zh: "配送中", en: "Out for delivery", ms: "Dalam penghantaran" },
    in_transit: { zh: "运送中", en: "In transit", ms: "Dalam perjalanan" },
    delivered: { zh: "已送达", en: "Delivered", ms: "Dihantar" },
    completed: { zh: "已完成", en: "Completed", ms: "Selesai" },
    cancelled: { zh: "已取消", en: "Cancelled", ms: "Dibatalkan" },
};
const RIDER = {
    ASSIGNING_DRIVER: { zh: "正在找骑手", en: "Finding a rider", ms: "Mencari penunggang" },
    ON_GOING: { zh: "骑手前往餐厅取餐", en: "Rider heading to the restaurant", ms: "Penunggang menuju ke restoran" },
    PICKED_UP: { zh: "骑手已取餐，配送中", en: "Rider picked up, on the way", ms: "Penunggang telah mengambil, dalam perjalanan" },
    COMPLETED: { zh: "已送达", en: "Delivered", ms: "Dihantar" },
    CANCELED: { zh: "叫车已取消", en: "Booking cancelled", ms: "Tempahan dibatalkan" },
    REJECTED: { zh: "骑手拒单", en: "Rider rejected", ms: "Penunggang menolak" },
    // pseudo status (not a Lalamove value): a driver who had accepted dropped the job and Lalamove is matching a new one
    DRIVER_REJECTED: { zh: "骑手已拒单，重新寻找骑手", en: "Rider declined — finding a new rider", ms: "Penunggang menolak — mencari penunggang baharu" },
    EXPIRED: { zh: "叫车已过期", en: "Booking expired", ms: "Tempahan tamat tempoh" },
};
export function orderStatusLabel(status, lang = "zh") {
    const hit = status ? ORDER[status.trim().toLowerCase().replace(/[\s-]+/g, "_")] : undefined;
    return hit?.[lang3(lang)];
}
export function riderStatusLabel(status, lang = "zh") {
    const hit = status ? RIDER[status.trim().toUpperCase()] : undefined;
    return hit?.[lang3(lang)];
}
//# sourceMappingURL=statusLabels.js.map